module.exports = __webpack_public_path__ + "img/jo.837db744.svg";